module.exports = __webpack_public_path__ + "static/media/flv.b2e33011.png";